export interface EmojiItem {
  emoji: string;
  name: string;
  keywords: string[];
}

export interface EmojiCategory {
  id:
    | 'smileys'
    | 'people'
    | 'animals'
    | 'food'
    | 'travel'
    | 'activities'
    | 'objects'
    | 'symbols'
    | 'flags';
  label: string;
  iconEmoji: string;
  items: EmojiItem[];
}

const createEmojiItem = (
  emoji: string,
  name: string,
  keywords: string[] = []
): EmojiItem => ({
  emoji,
  name,
  keywords,
});

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smileys',
    label: 'Смайлы',
    iconEmoji: '😀',
    items: [
      createEmojiItem('😀', 'улыбка', ['smile', 'happy', 'радость']),
      createEmojiItem('😃', 'широкая улыбка', ['grin', 'happy']),
      createEmojiItem('😄', 'смеется', ['laugh', 'joy']),
      createEmojiItem('😁', 'довольный', ['grin', 'teeth']),
      createEmojiItem('😆', 'смех с закрытыми глазами', ['laugh', 'lol']),
      createEmojiItem('😅', 'нервный смех', ['sweat', 'relief']),
      createEmojiItem('🤣', 'катаюсь от смеха', ['rofl', 'lol']),
      createEmojiItem('😂', 'слезы радости', ['joy', 'laugh']),
      createEmojiItem('🙂', 'легкая улыбка', ['smile']),
      createEmojiItem('🙃', 'перевернутый смайл', ['upside down']),
      createEmojiItem('😉', 'подмигивание', ['wink']),
      createEmojiItem('😊', 'смущенная улыбка', ['blush', 'happy']),
      createEmojiItem('😇', 'ангел', ['angel', 'innocent']),
      createEmojiItem('🥰', 'любовь', ['love', 'hearts']),
      createEmojiItem('😍', 'влюбленный', ['heart eyes', 'love']),
      createEmojiItem('🤩', 'звездные глаза', ['star', 'wow']),
      createEmojiItem('😘', 'поцелуй', ['kiss']),
      createEmojiItem('😗', 'целует', ['kiss']),
      createEmojiItem('😚', 'поцелуй с закрытыми глазами', ['kiss']),
      createEmojiItem('😋', 'вкусно', ['yum', 'food']),
      createEmojiItem('😛', 'язык', ['tongue']),
      createEmojiItem('😜', 'подмигивает с языком', ['wink', 'tongue']),
      createEmojiItem('🤪', 'безумный', ['crazy', 'fun']),
      createEmojiItem('😎', 'крутой', ['cool', 'sunglasses']),
      createEmojiItem('🥳', 'праздник', ['party', 'celebrate']),
      createEmojiItem('😏', 'ухмылка', ['smirk']),
      createEmojiItem('😒', 'недовольный', ['unamused']),
      createEmojiItem('😔', 'грусть', ['sad']),
      createEmojiItem('😢', 'плачет', ['cry', 'tear']),
      createEmojiItem('😭', 'рыдает', ['cry', 'sob']),
      createEmojiItem('😡', 'злость', ['angry']),
      createEmojiItem('😱', 'страх', ['scream', 'shock']),
      createEmojiItem('😴', 'сон', ['sleep']),
      createEmojiItem('🤔', 'думает', ['thinking']),
      createEmojiItem('🤗', 'объятия', ['hug']),
      createEmojiItem('🤫', 'тихо', ['shh']),
      createEmojiItem('🙄', 'закатил глаза', ['eyeroll']),
      createEmojiItem('😬', 'неловко', ['grimace']),
      createEmojiItem('😮‍💨', 'выдох', ['relief', 'sigh']),
      createEmojiItem('❤️', 'красное сердце', ['heart', 'love']),
      createEmojiItem('🧡', 'оранжевое сердце', ['heart']),
      createEmojiItem('💛', 'желтое сердце', ['heart']),
      createEmojiItem('💚', 'зеленое сердце', ['heart']),
      createEmojiItem('💙', 'синее сердце', ['heart']),
      createEmojiItem('💜', 'фиолетовое сердце', ['heart']),
    ],
  },
  {
    id: 'people',
    label: 'Люди',
    iconEmoji: '👍',
    items: [
      createEmojiItem('👋', 'привет', ['wave', 'hello']),
      createEmojiItem('🤚', 'поднятая рука', ['hand']),
      createEmojiItem('🖐️', 'ладонь', ['hand']),
      createEmojiItem('✋', 'стоп', ['stop', 'hand']),
      createEmojiItem('👌', 'окей', ['ok']),
      createEmojiItem('🤌', 'щепотка', ['pinched fingers']),
      createEmojiItem('🤏', 'чуть-чуть', ['small']),
      createEmojiItem('✌️', 'победа', ['victory', 'peace']),
      createEmojiItem('🤞', 'скрещенные пальцы', ['luck']),
      createEmojiItem('🤟', 'люблю', ['love you']),
      createEmojiItem('🤘', 'рок', ['rock']),
      createEmojiItem('🤙', 'позвони', ['call']),
      createEmojiItem('👈', 'налево', ['left']),
      createEmojiItem('👉', 'направо', ['right']),
      createEmojiItem('👆', 'вверх', ['up']),
      createEmojiItem('👇', 'вниз', ['down']),
      createEmojiItem('☝️', 'указатель', ['index']),
      createEmojiItem('👍', 'лайк', ['like', 'thumbs up']),
      createEmojiItem('👎', 'дизлайк', ['dislike', 'thumbs down']),
      createEmojiItem('✊', 'кулак', ['fist']),
      createEmojiItem('👊', 'кулак вперед', ['fist bump']),
      createEmojiItem('👏', 'аплодисменты', ['clap']),
      createEmojiItem('🙌', 'ура', ['raise hands']),
      createEmojiItem('👐', 'открытые руки', ['hands']),
      createEmojiItem('🤲', 'ладони', ['palms']),
      createEmojiItem('🙏', 'спасибо', ['please', 'thanks']),
      createEmojiItem('💪', 'сила', ['strong', 'muscle']),
      createEmojiItem('🫶', 'сердце руками', ['heart hands']),
      createEmojiItem('👀', 'глаза', ['eyes', 'look']),
      createEmojiItem('🧠', 'мозг', ['brain']),
      createEmojiItem('👶', 'ребенок', ['baby']),
      createEmojiItem('👩', 'женщина', ['woman']),
      createEmojiItem('👨', 'мужчина', ['man']),
      createEmojiItem('🧑‍💻', 'специалист за компьютером', ['developer']),
      createEmojiItem('👩‍⚕️', 'врач', ['doctor']),
      createEmojiItem('👩‍💼', 'офисный сотрудник', ['office']),
      createEmojiItem('🧘', 'медитация', ['yoga']),
      createEmojiItem('💃', 'танец', ['dance']),
      createEmojiItem('🏃', 'бег', ['run']),
      createEmojiItem('🤷', 'не знаю', ['shrug']),
    ],
  },
  {
    id: 'animals',
    label: 'Животные',
    iconEmoji: '🐶',
    items: [
      createEmojiItem('🐶', 'собака', ['dog']),
      createEmojiItem('🐱', 'кот', ['cat']),
      createEmojiItem('🐭', 'мышь', ['mouse']),
      createEmojiItem('🐹', 'хомяк', ['hamster']),
      createEmojiItem('🐰', 'кролик', ['rabbit']),
      createEmojiItem('🦊', 'лиса', ['fox']),
      createEmojiItem('🐻', 'медведь', ['bear']),
      createEmojiItem('🐼', 'панда', ['panda']),
      createEmojiItem('🐨', 'коала', ['koala']),
      createEmojiItem('🐯', 'тигр', ['tiger']),
      createEmojiItem('🦁', 'лев', ['lion']),
      createEmojiItem('🐮', 'корова', ['cow']),
      createEmojiItem('🐷', 'свинья', ['pig']),
      createEmojiItem('🐸', 'лягушка', ['frog']),
      createEmojiItem('🐵', 'обезьяна', ['monkey']),
      createEmojiItem('🐔', 'курица', ['chicken']),
      createEmojiItem('🐧', 'пингвин', ['penguin']),
      createEmojiItem('🐦', 'птица', ['bird']),
      createEmojiItem('🦆', 'утка', ['duck']),
      createEmojiItem('🦅', 'орел', ['eagle']),
      createEmojiItem('🦉', 'сова', ['owl']),
      createEmojiItem('🦋', 'бабочка', ['butterfly']),
      createEmojiItem('🐝', 'пчела', ['bee']),
      createEmojiItem('🐞', 'жук', ['bug']),
      createEmojiItem('🐢', 'черепаха', ['turtle']),
      createEmojiItem('🐍', 'змея', ['snake']),
      createEmojiItem('🦎', 'ящерица', ['lizard']),
      createEmojiItem('🐙', 'осьминог', ['octopus']),
      createEmojiItem('🦑', 'кальмар', ['squid']),
      createEmojiItem('🦐', 'креветка', ['shrimp']),
      createEmojiItem('🐠', 'рыба', ['fish']),
      createEmojiItem('🐬', 'дельфин', ['dolphin']),
      createEmojiItem('🌵', 'кактус', ['cactus']),
      createEmojiItem('🌲', 'елка', ['tree']),
      createEmojiItem('🌸', 'сакура', ['flower']),
      createEmojiItem('🌹', 'роза', ['rose']),
      createEmojiItem('🌻', 'подсолнух', ['sunflower']),
      createEmojiItem('🍀', 'клевер', ['luck']),
      createEmojiItem('🌿', 'трава', ['herb']),
      createEmojiItem('🍁', 'лист', ['leaf']),
    ],
  },
  {
    id: 'food',
    label: 'Еда',
    iconEmoji: '🍔',
    items: [
      createEmojiItem('🍏', 'зеленое яблоко', ['apple']),
      createEmojiItem('🍎', 'яблоко', ['apple']),
      createEmojiItem('🍐', 'груша', ['pear']),
      createEmojiItem('🍊', 'апельсин', ['orange']),
      createEmojiItem('🍋', 'лимон', ['lemon']),
      createEmojiItem('🍌', 'банан', ['banana']),
      createEmojiItem('🍉', 'арбуз', ['watermelon']),
      createEmojiItem('🍇', 'виноград', ['grapes']),
      createEmojiItem('🍓', 'клубника', ['strawberry']),
      createEmojiItem('🫐', 'черника', ['blueberry']),
      createEmojiItem('🍒', 'вишня', ['cherry']),
      createEmojiItem('🥝', 'киви', ['kiwi']),
      createEmojiItem('🍅', 'помидор', ['tomato']),
      createEmojiItem('🥑', 'авокадо', ['avocado']),
      createEmojiItem('🥦', 'брокколи', ['broccoli']),
      createEmojiItem('🥕', 'морковь', ['carrot']),
      createEmojiItem('🌽', 'кукуруза', ['corn']),
      createEmojiItem('🥐', 'круассан', ['croissant']),
      createEmojiItem('🍞', 'хлеб', ['bread']),
      createEmojiItem('🥞', 'панкейки', ['pancakes']),
      createEmojiItem('🧀', 'сыр', ['cheese']),
      createEmojiItem('🍖', 'мясо', ['meat']),
      createEmojiItem('🍗', 'куриная ножка', ['chicken']),
      createEmojiItem('🍔', 'бургер', ['burger']),
      createEmojiItem('🍟', 'картошка фри', ['fries']),
      createEmojiItem('🍕', 'пицца', ['pizza']),
      createEmojiItem('🌭', 'хот-дог', ['hotdog']),
      createEmojiItem('🥪', 'сэндвич', ['sandwich']),
      createEmojiItem('🌮', 'тако', ['taco']),
      createEmojiItem('🍣', 'суши', ['sushi']),
      createEmojiItem('🍜', 'лапша', ['noodles']),
      createEmojiItem('🍝', 'паста', ['pasta']),
      createEmojiItem('🍰', 'торт', ['cake']),
      createEmojiItem('🧁', 'капкейк', ['cupcake']),
      createEmojiItem('🍫', 'шоколад', ['chocolate']),
      createEmojiItem('🍿', 'попкорн', ['popcorn']),
      createEmojiItem('☕', 'кофе', ['coffee']),
      createEmojiItem('🍵', 'чай', ['tea']),
      createEmojiItem('🥤', 'напиток', ['drink']),
      createEmojiItem('🍷', 'вино', ['wine']),
    ],
  },
  {
    id: 'travel',
    label: 'Места',
    iconEmoji: '🚗',
    items: [
      createEmojiItem('🚗', 'машина', ['car']),
      createEmojiItem('🚕', 'такси', ['taxi']),
      createEmojiItem('🚌', 'автобус', ['bus']),
      createEmojiItem('🚎', 'троллейбус', ['trolleybus']),
      createEmojiItem('🏎️', 'гоночная машина', ['race car']),
      createEmojiItem('🚓', 'полиция', ['police']),
      createEmojiItem('🚑', 'скорая', ['ambulance']),
      createEmojiItem('🚒', 'пожарная машина', ['fire truck']),
      createEmojiItem('🚚', 'грузовик', ['truck']),
      createEmojiItem('🚲', 'велосипед', ['bike']),
      createEmojiItem('🛴', 'самокат', ['scooter']),
      createEmojiItem('✈️', 'самолет', ['plane']),
      createEmojiItem('🚀', 'ракета', ['rocket']),
      createEmojiItem('🚁', 'вертолет', ['helicopter']),
      createEmojiItem('🚢', 'корабль', ['ship']),
      createEmojiItem('🏠', 'дом', ['home']),
      createEmojiItem('🏢', 'офис', ['office']),
      createEmojiItem('🏥', 'больница', ['hospital']),
      createEmojiItem('🏦', 'банк', ['bank']),
      createEmojiItem('🏨', 'отель', ['hotel']),
      createEmojiItem('🏪', 'магазин', ['store']),
      createEmojiItem('🏫', 'школа', ['school']),
      createEmojiItem('🏖️', 'пляж', ['beach']),
      createEmojiItem('🏕️', 'кемпинг', ['camping']),
      createEmojiItem('⛰️', 'гора', ['mountain']),
      createEmojiItem('🌋', 'вулкан', ['volcano']),
      createEmojiItem('🗽', 'статуя свободы', ['statue']),
      createEmojiItem('🗼', 'башня', ['tower']),
      createEmojiItem('🎡', 'колесо обозрения', ['ferris wheel']),
      createEmojiItem('🌍', 'земля Европа Африка', ['earth']),
      createEmojiItem('🌎', 'земля Америка', ['earth']),
      createEmojiItem('🌏', 'земля Азия', ['earth']),
      createEmojiItem('☀️', 'солнце', ['sun']),
      createEmojiItem('🌙', 'луна', ['moon']),
      createEmojiItem('⭐', 'звезда', ['star']),
      createEmojiItem('🌧️', 'дождь', ['rain']),
      createEmojiItem('❄️', 'снег', ['snow']),
      createEmojiItem('🌈', 'радуга', ['rainbow']),
    ],
  },
  {
    id: 'activities',
    label: 'Активности',
    iconEmoji: '⚽',
    items: [
      createEmojiItem('⚽', 'футбол', ['football', 'soccer']),
      createEmojiItem('🏀', 'баскетбол', ['basketball']),
      createEmojiItem('🏈', 'американский футбол', ['football']),
      createEmojiItem('⚾', 'бейсбол', ['baseball']),
      createEmojiItem('🎾', 'теннис', ['tennis']),
      createEmojiItem('🏐', 'волейбол', ['volleyball']),
      createEmojiItem('🏉', 'регби', ['rugby']),
      createEmojiItem('🎱', 'бильярд', ['pool']),
      createEmojiItem('🏓', 'пинг-понг', ['ping pong']),
      createEmojiItem('🏸', 'бадминтон', ['badminton']),
      createEmojiItem('🥊', 'бокс', ['boxing']),
      createEmojiItem('🏆', 'кубок', ['trophy']),
      createEmojiItem('🥇', 'золото', ['gold medal']),
      createEmojiItem('🥈', 'серебро', ['silver medal']),
      createEmojiItem('🥉', 'бронза', ['bronze medal']),
      createEmojiItem('🎮', 'игры', ['game']),
      createEmojiItem('🎲', 'кубик', ['dice']),
      createEmojiItem('♟️', 'шахматы', ['chess']),
      createEmojiItem('🎯', 'цель', ['target']),
      createEmojiItem('🎳', 'боулинг', ['bowling']),
      createEmojiItem('🎨', 'рисование', ['art']),
      createEmojiItem('🎭', 'театр', ['theater']),
      createEmojiItem('🎤', 'микрофон', ['microphone']),
      createEmojiItem('🎧', 'наушники', ['headphones']),
      createEmojiItem('🎼', 'ноты', ['music']),
      createEmojiItem('🎹', 'пианино', ['piano']),
      createEmojiItem('🥁', 'барабан', ['drum']),
      createEmojiItem('🎬', 'кино', ['movie']),
      createEmojiItem('🎫', 'билет', ['ticket']),
      createEmojiItem('🎁', 'подарок', ['gift']),
      createEmojiItem('🎈', 'шарик', ['balloon']),
      createEmojiItem('🎉', 'хлопушка', ['party']),
      createEmojiItem('🎊', 'конфетти', ['confetti']),
      createEmojiItem('✨', 'искры', ['sparkles']),
      createEmojiItem('🔥', 'огонь', ['fire']),
    ],
  },
  {
    id: 'objects',
    label: 'Объекты',
    iconEmoji: '💡',
    items: [
      createEmojiItem('⌚', 'часы', ['watch']),
      createEmojiItem('📱', 'телефон', ['phone']),
      createEmojiItem('💻', 'ноутбук', ['laptop']),
      createEmojiItem('⌨️', 'клавиатура', ['keyboard']),
      createEmojiItem('🖥️', 'монитор', ['desktop']),
      createEmojiItem('🖨️', 'принтер', ['printer']),
      createEmojiItem('🖱️', 'мышь', ['mouse']),
      createEmojiItem('💾', 'дискета', ['save']),
      createEmojiItem('💿', 'диск', ['disc']),
      createEmojiItem('📷', 'камера', ['camera']),
      createEmojiItem('🎥', 'видеокамера', ['video camera']),
      createEmojiItem('📺', 'телевизор', ['tv']),
      createEmojiItem('📻', 'радио', ['radio']),
      createEmojiItem('⏰', 'будильник', ['alarm']),
      createEmojiItem('💡', 'лампочка', ['idea', 'light']),
      createEmojiItem('🔦', 'фонарик', ['flashlight']),
      createEmojiItem('🕯️', 'свеча', ['candle']),
      createEmojiItem('🧯', 'огнетушитель', ['fire extinguisher']),
      createEmojiItem('💵', 'доллары', ['money']),
      createEmojiItem('💳', 'карта', ['card']),
      createEmojiItem('🧾', 'чек', ['receipt']),
      createEmojiItem('💎', 'бриллиант', ['diamond']),
      createEmojiItem('🔧', 'ключ', ['wrench']),
      createEmojiItem('🔨', 'молоток', ['hammer']),
      createEmojiItem('🛠️', 'инструменты', ['tools']),
      createEmojiItem('🧰', 'ящик инструментов', ['toolbox']),
      createEmojiItem('🧲', 'магнит', ['magnet']),
      createEmojiItem('🧪', 'пробирка', ['test tube']),
      createEmojiItem('💊', 'таблетка', ['pill']),
      createEmojiItem('🩹', 'пластырь', ['bandage']),
      createEmojiItem('🧼', 'мыло', ['soap']),
      createEmojiItem('🪥', 'зубная щетка', ['toothbrush']),
      createEmojiItem('🧴', 'лосьон', ['lotion']),
      createEmojiItem('🛒', 'корзина', ['cart']),
      createEmojiItem('🎀', 'лента', ['ribbon']),
      createEmojiItem('✉️', 'письмо', ['email']),
      createEmojiItem('📌', 'булавка', ['pin']),
      createEmojiItem('📎', 'скрепка', ['paperclip']),
      createEmojiItem('📅', 'календарь', ['calendar']),
      createEmojiItem('📋', 'буфер', ['clipboard']),
    ],
  },
  {
    id: 'symbols',
    label: 'Символы',
    iconEmoji: '✅',
    items: [
      createEmojiItem('✅', 'галочка', ['check', 'done']),
      createEmojiItem('☑️', 'чекбокс', ['checkbox']),
      createEmojiItem('✔️', 'отметка', ['check']),
      createEmojiItem('❌', 'крестик', ['cross', 'no']),
      createEmojiItem('⭕', 'круг', ['circle']),
      createEmojiItem('⛔', 'запрещено', ['stop']),
      createEmojiItem('🚫', 'нельзя', ['forbidden']),
      createEmojiItem('⚠️', 'внимание', ['warning']),
      createEmojiItem('❗', 'восклицание', ['exclamation']),
      createEmojiItem('❓', 'вопрос', ['question']),
      createEmojiItem('💯', 'сто', ['hundred']),
      createEmojiItem('🔴', 'красный круг', ['red']),
      createEmojiItem('🟠', 'оранжевый круг', ['orange']),
      createEmojiItem('🟡', 'желтый круг', ['yellow']),
      createEmojiItem('🟢', 'зеленый круг', ['green']),
      createEmojiItem('🔵', 'синий круг', ['blue']),
      createEmojiItem('🟣', 'фиолетовый круг', ['purple']),
      createEmojiItem('⚫', 'черный круг', ['black']),
      createEmojiItem('⚪', 'белый круг', ['white']),
      createEmojiItem('⬆️', 'стрелка вверх', ['up']),
      createEmojiItem('⬇️', 'стрелка вниз', ['down']),
      createEmojiItem('⬅️', 'стрелка влево', ['left']),
      createEmojiItem('➡️', 'стрелка вправо', ['right']),
      createEmojiItem('🔄', 'обновить', ['refresh']),
      createEmojiItem('🔁', 'повтор', ['repeat']),
      createEmojiItem('▶️', 'пуск', ['play']),
      createEmojiItem('⏸️', 'пауза', ['pause']),
      createEmojiItem('⏹️', 'стоп', ['stop']),
      createEmojiItem('🔔', 'уведомление', ['bell']),
      createEmojiItem('🔕', 'без звука', ['mute']),
      createEmojiItem('♻️', 'переработка', ['recycle']),
      createEmojiItem('🔒', 'замок', ['lock']),
      createEmojiItem('🔓', 'открыто', ['unlock']),
      createEmojiItem('❤️‍🔥', 'горящее сердце', ['heart fire']),
      createEmojiItem('💤', 'сон', ['sleep']),
      createEmojiItem('💬', 'сообщение', ['message']),
      createEmojiItem('🕐', 'время', ['time']),
    ],
  },
  {
    id: 'flags',
    label: 'Флаги',
    iconEmoji: '🏳️',
    items: [
      createEmojiItem('🏳️', 'белый флаг', ['white flag']),
      createEmojiItem('🏴', 'черный флаг', ['black flag']),
      createEmojiItem('🏁', 'финишный флаг', ['checkered flag']),
      createEmojiItem('🚩', 'красный флаг', ['red flag']),
      createEmojiItem('🇷🇺', 'Россия', ['russia']),
      createEmojiItem('🇺🇸', 'США', ['usa', 'united states']),
      createEmojiItem('🇬🇧', 'Великобритания', ['uk', 'great britain']),
      createEmojiItem('🇩🇪', 'Германия', ['germany']),
      createEmojiItem('🇫🇷', 'Франция', ['france']),
      createEmojiItem('🇮🇹', 'Италия', ['italy']),
      createEmojiItem('🇪🇸', 'Испания', ['spain']),
      createEmojiItem('🇵🇹', 'Португалия', ['portugal']),
      createEmojiItem('🇳🇱', 'Нидерланды', ['netherlands']),
      createEmojiItem('🇵🇱', 'Польша', ['poland']),
      createEmojiItem('🇺🇦', 'Украина', ['ukraine']),
      createEmojiItem('🇧🇾', 'Беларусь', ['belarus']),
      createEmojiItem('🇰🇿', 'Казахстан', ['kazakhstan']),
      createEmojiItem('🇦🇲', 'Армения', ['armenia']),
      createEmojiItem('🇬🇪', 'Грузия', ['georgia']),
      createEmojiItem('🇹🇷', 'Турция', ['turkey']),
      createEmojiItem('🇨🇳', 'Китай', ['china']),
      createEmojiItem('🇯🇵', 'Япония', ['japan']),
      createEmojiItem('🇰🇷', 'Корея', ['korea']),
      createEmojiItem('🇮🇳', 'Индия', ['india']),
      createEmojiItem('🇧🇷', 'Бразилия', ['brazil']),
      createEmojiItem('🇨🇦', 'Канада', ['canada']),
      createEmojiItem('🇦🇺', 'Австралия', ['australia']),
      createEmojiItem('🇲🇽', 'Мексика', ['mexico']),
      createEmojiItem('🇦🇪', 'ОАЭ', ['uae']),
      createEmojiItem('🇸🇦', 'Саудовская Аравия', ['saudi arabia']),
    ],
  },
];
